import { getCompanyInfo } from 'Api/companyApi'

/**
 * @param {CompanyAccount} model
 * @returns {Promise.<ApiCompanyAccountEdit>}
 */
export const formatCompanyAccountAsync = async (model) => {
  const avoidPipe = item => item.replace('|', '/')

  try {
    const { data } = await getCompanyInfo()

    return {
      registryName: data.registryName,
      fancyName: model.name,
      cnpJ_CPF: data.cnpJ_CPF,
      servicesDescription: model.serviceDescription,
      reference: model.endorsementList.map(avoidPipe).join('|'),
      differential: model.advantangeList.map(avoidPipe).join('|'),
      about: model.about,
      site: model.website,
      phone: {
        ddd: model.phone.ddd,
        number: model.phone.number.replace('-', ''),
        isMain: true,
      }
    }
  } catch (err) {
    throw err
  }
}

export default {
  formatCompanyAccountAsync
}